<template>
  <common-dialog ref="dialog" :data="data" :form-rules="rules" :get-data-func="api.info" :save-func="() => { }"
    title="投诉处理" width="920px" @close-saved="$emit('close-saved')" @closed="onClosed">
    <template slot="form">
      <el-row>
        <span class>基础信息</span>
      </el-row>
      <el-row class="row-border" prop="ComplainType">
        <el-form-item label="投诉类型">
          <span>{{ data.ComplainType }}</span>
        </el-form-item>
        <el-col :span="12">
          <el-form-item label="投诉对象" prop="MemberName">
            <span>{{ data.MemberName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="投诉日期" prop="complainDate">
            <span>{{ data.ComplainDate }}</span>
          </el-form-item>
        </el-col>
        <el-form-item label="投诉内容" prop="Content">
          <span>{{ data.Content }}</span>
        </el-form-item>
        <el-form-item label="投诉人员" prop="StudentName">
          <span>{{ data.Anonymous ? "匿名" : data.StudentName }}</span>
        </el-form-item>
        <el-form-item label="处理结果" prop="Result" :rules="data.ResultStatus == 2 ? rules : null">
          <el-input v-model="data.Result" placeholder="请输入内容" type="textarea" maxlength="80"></el-input>
        </el-form-item>
        <el-col :span="12">
          <el-form-item label="处理状态">
            <el-select v-model="data.ResultStatus" @change="isValid">
              <el-option :value="1" label="已受理"></el-option>
              <el-option :value="2" label="已处理"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <template slot="footer" slot-scope="{isLoading}">
      <template >
        <!-- <template v-if="(data.Status == 0 || data.Status == 2) "> -->
        <el-button type="warning" :loading="isLoading" @click.stop="toSave('save')">保 存</el-button>
        <el-button type="primary" :loading="isLoading" v-if="data.Status == 0 || data.Status == 2"
          @click.stop="toSave('submit')">提 交</el-button>
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>

<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    // let validator = (rule, value, callback) => {
    //   if (this.data.ResultStatus == 2 && this.data.Result == "") {
    //     callback("内容不能为空");
    //   } else {
    //     callback();
    //   }
    // };
    return {
      userInfo: JSON.parse(localStorage.getItem("loginInfo")),
      api: require("@/api/consult/complaint").default,
      data: {
        ComplainId: 0,
        DpId: 0,
        ComplainType: "",
        MemberType: 0,
        MemberId: 0,
        Content: "",
        ComplainDate: "",
        StudentId: 0,
        Anonymous: true,
        Status: 0,
        Result: "",
        ResultStatus: 1,
        ResultUserId: 0,
        ResultTime: "",
        DpName: "",
        DpIdChain: "",
        MemberName: "",
        StudentName: "",
      },
      isSubmit: false,
      type: "",
      rules: { required: true, message: "内容不能为空" },
    };
  },

  methods: {
    onClosed() {

    },
    isValid(i) {
      this.$refs.dialog.clearValidate();
    },
    toSave(type) {
      this.isSubmit = type == 1;

      this.api[type](this.data).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });

    },
  },
};
</script>

<style scoped>
</style>
